import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { UserGroupStore } from '@seedlang/stores';
import autobind from 'autobind-decorator';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import Grid from 'components/layout/grid';
import ButtonPrimary from 'components/button/button_primary';

@observer
class UserCreate extends React.Component {
  @observable showCreatedMessage = false;
  @observable message = '';
  @observable testAccount = false;

  @autobind onCreate() {
    UserGroupStore.addUser(
      {
        data: {
          email: this.refs.email.value,
          password: this.refs.password.value,
          passwordConfirmation: this.refs.password.value,
          test_account: this.testAccount,
        },
      },
    this.afterCreate);
  }

  @autobind afterCreate() {
    this.refs.email.value = '';
    this.refs.password.value = '';
    this.showCreatedMessage = true;
    this.message = 'A user was successfully added.';
  }

  render() {
    return (
      <div className='concept-category-create'>
        {
          this.showCreatedMessage &&
            <div className='alert'>
              {this.message}
            </div>
        }
        <h3>Create One</h3>
        <Grid columns={2} gap='sm'>
          <input
            placeholder='Add a email'
            ref='email'
          />
          <input
            placeholder='Add a password'
            ref='password'
          />
        </Grid>
        <InPlaceCheckbox
          onChange={() => this.testAccount = !this.testAccount}
          checked={this.testAccount}
        >
          Test Account
        </InPlaceCheckbox>
        <ButtonPrimary onClick={this.onCreate}>
          Create
        </ButtonPrimary>
      </div>
    );
  }
}

export default UserCreate;
